import $ from 'jquery';

$('.filter-toggle').on('click', () => {
    $('.filter').toggleClass('filter--active');
});

$('.filter .menu-item-has-children > a').on('click', function (e) {
    e.stopPropagation();
    e.preventDefault();
    e.stopImmediatePropagation();

    const currentList = $(this).closest('li');
    const currentMenu = currentList.find('.sub-menu');

    currentList.toggleClass('submenu-active');
    currentMenu.slideToggle('300');
});

$('.filter__menu--products a').each(function () {
    const $this = $(this);
    const parent = $this.parent();
    const children = parent.find('.children');
    const linkHref = $this.attr('href');

    if (children.length) {
        $this.attr('href', '#');
        children.before(
            '<button type="button" class="children-button"><i class="gral-icons-arrow-right"></i></button>'
        );
        children.append(
            '<li class="see-all"><a href="' + linkHref +'" >Voir tous les produits</a></li><button type="button" class="submenu-close submenu-close--bottom"><i class="gral-icons-angle-left"></i></button>'
        );
        children.prepend(
            '<div class="mobile-menu-title"><button type="button" class="submenu-close"><i class="gral-icons-angle-left"></i></button>' + $this.html() +'</div>'
        );
        parent.addClass('has-children')
    }
});

$(document).on(
    'click',
    '.filter__menu--products .has-children',
    function (e) {
        const $this = $(this);

        if ( ! $this.hasClass('submenu-active')) {
            e.stopPropagation();
            e.preventDefault();
            e.stopImmediatePropagation();
            $('.submenu-active').find('ul').animate( {width: 'toggle'}, 200, function () {
                $('.submenu-active').removeClass('submenu-active');
                const currentMenu = $this.find('ul');

                $this.toggleClass('submenu-active');
                currentMenu.animate({width: 'toggle'});
            });

            if ( ! $('.submenu-active').length ) {
                const currentMenu = $this.find('ul');

                $this.toggleClass('submenu-active');
                currentMenu.animate({width: 'toggle'}, 200);
            }
        }
    }
);

$('.submenu-close').on('click', function (e) {
    e.stopPropagation();
    e.preventDefault();
    e.stopImmediatePropagation();

    const currentList = $(this).closest('li');
    const currentMenu = currentList.find('ul');

    currentMenu.animate({width: 'toggle'}, 200, function () {
        currentList.removeClass('submenu-active');
    });
});

$('.filter__has-submenu > a').on('click', function (e) {
    e.stopPropagation();
    e.preventDefault();
    e.stopImmediatePropagation();

    const currentList = $(this).closest('li');
    const currentMenu = currentList.find('ul');

    currentList.toggleClass('submenu-active');
    currentMenu.animate({width: 'toggle'}, 200);
});

const setOpenerPos = () => {
    const bodyWidth = $('body').outerWidth();
    const containerWidth = $('.container').outerWidth();
    const opener = $('.filter-opener');
    const pos = (bodyWidth - containerWidth) / 2 - 80;

    if (window.matchMedia('(min-width: 575px)').matches && pos >= 100) {
        opener.css({
            left: `calc(${(bodyWidth - containerWidth) / 2 - 80}px)`,
        });
    } else {
        opener.css({
            left: '20px',
        });
    }
};

$('.filter--recipes .filter__menu a').on('click', () => {
    if (window.matchMedia('(max-width: 575px)').matches) {
        $('.filter--recipes').removeClass('filter--active');
    }
});

$(window).on('resize', setOpenerPos).trigger('resize');

$('.product-filter-close').click(function () {
    document.getElementById('product-input').value = '';
    document.getElementById('distributor-filter-submit').submit();

});
